<template>
  <Datepicker
      :class="classString"
      :placeholder="placeholder"
      v-model="model"
      :format="format"
      :minimum-view="minimumView"
      :disabled="disabledDates">
  </Datepicker>
</template>

<script>
  import moment from 'moment';
  import Datepicker from 'vuejs-datepicker';

  export default {
    name: 'StoreConnectedDatePicker',
    components: {
      Datepicker,
    },
    props: {
      store: {
        type: String,
        required: true,
      },
      action: {
        type: String,
        default: 'setProperty',
      },
      name: {
        type: String,
        required: true,
      },
      subProp: {
        default: null,
      },
      field: {
        type: String,
      },
      minimumView: {
        type: String,
        default: 'month',
      },
      format: {
        type: String,
        default: 'MM/yyyy',
      },
      placeholder: {
        type: String,
        default: '',
      },
      disabledDates: {
        type: Object,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      futureOnly: {
        type: Boolean,
        default: false,
      },
      deleteOnDisabled: {
        type: Boolean,
        default: true,
      },
      classString: {
        type: String,
        default: 'h-full-width',
      },
      maxDate: {},
      minDate: {},
      callback: {
        default: null,
      },
      clearable: {
        type: Boolean,
        default:false,
      },
    },
    data() {
      return {
        model: null,
      };
    },
    mounted() {
      if (this.subProp) {
        this.model = this.$store.getters[`${this.store}/${this.name}`][this.subProp];
      } else {
        this.model = this.$store.getters[`${this.store}/${this.name}`];
      }
    },
    watch: {
      minDateComputed(newValue) {
        if (this.model < newValue) {
          this.model = newValue;
        }
      },
      maxDate(newValue) {
        if (this.model > newValue) {
          this.model = newValue;
        }
      },
      minDate(newValue) {
        if (this.model < newValue) {
          this.model = newValue;
        }
      },
      model(newValue) {
        this.updateStore();
        if (this.callback) {
          this.$store.dispatch(this.callback, newValue);
        }
      },
      disabled() {
        if (this.deleteOnDisabled) {
          this.model = null;
        }
      },
      computedModel(newValue, oldValue) {
        if (!newValue || moment(newValue).format('YYYY-MM-DD') !== moment(oldValue).format('YYYY-MM-DD')) {
          this.model = newValue;
        }
      },
    },
    computed: {
      payload() {
        const thePayload = {
          key: this.modelName,
          value: this.model,
        };
        if (this.subProp) {
          thePayload.object = this.name;
        }
        return thePayload;
      },
      computedModel() {
        if (this.subProp) {
          return this.$store.getters[`${this.store}/${this.name}`][this.subProp];
        } else {
          return this.$store.getters[`${this.store}/${this.name}`];
        }
      },
      modelName() {
        return this.subProp || this.name;
      },
      minDateComputed() {
        return this.futureOnly ? new Date() : this.minDate;
      },
    },
    methods: {
      updateStore() {
        this.$store.dispatch(`${this.store}/${this.action}`, this.payload);
      },
      clearDate() {
        this.model = null;
      },
    },
  };
</script>
